// @ts-expect-error untyped loader
import _quickFetch from 'exports-loader?exports=default%20quickFetch!quick-fetch/internal/index';

// @ts-expect-error untyped loader
import * as currentPackage from 'current-package-loader!';
const quickFetch = _quickFetch;

// quick-fetch relies on these variables being set
quickFetch._currentProject = currentPackage.name;
quickFetch._currentProjectVersion = currentPackage.version;
export default quickFetch;